<template>
    <v-container class="ma-0 pa-0">
        <v-row>
            <v-col align="left">
                <h2>4 enkle trin</h2>
                <h4>gofiqr er dit helt eget professionelle QR-kode univers, der på én og samme tid kan hjælpe dig med med at
                    styrke din kundeinformation, interne videndeling og profilering.</h4>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="3" v-for="(step, i) in steps" :key="i" align="left">
                <h2>{{ i + 1 }}</h2>
                {{ step.text }}
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        name: 'FourSimpleSteps',
        props: {
        },
        data: () => ({
            steps: [
                {text: 'Har du, dine medarbejdere eller gæster ikke allerede en QR-kodescanner på jeres telefoner eller mobile enheder, så download en sikker version her: iOS, Android, Windows'},
                {text: 'Gå ind på din gofiqr-side, hvor du er administrator. Overvej hvilke informationer, retningslinier, vejledninger og evt. film/lydfiler, du med fordel kan dele med andre. Læg derefter de relevante informationer ind på siden - alt er nu automatisk  knyttet op imod dine unikke QR-koder.'},
                {text: 'Sæt dine QR-koder på de produkter, arbejdsstationer eller fysiske steder, du ønsker at koble til dit gofiqr-univers. Begynd evt. ét sted, du kan altid finde flere senere.'},
                {text: 'Alle med QR-kodescannere kan nu tilgå dine informationer, når de kommer forbi dine QR-koder. Sæt om nødvendigt en tekst, der fanger opmærksomheden, ved siden af din QR-kode, så folk får lyst til at scanne koden.'},
            ],
        }),
    }
</script>